import { Avatar } from "@mui/material";
import React, { FC } from "react";
import { AuthService, IMeetingConfirmation, IUser, getShortUserName } from "../../../../utils";
import { ConfirmationStatus } from "../../../confirmationStatus";

interface MemberProps {
  member: IUser;
  meetingConfirmation: IMeetingConfirmation[];
  initiator: IUser;
  offset: number;
}

export const Member: FC<MemberProps> = ({
  member, meetingConfirmation, initiator, offset
}) => {
  const userId = AuthService.getUserId()
  const isHideDetailingInformation = userId !== initiator.id;

  return (
    <div key={member.id} className="member">
      <Avatar sx={{ height: 24, width: 24 }} src={member.img} />
      <div>
        <div>{getShortUserName(member.fullName)}</div>
        {meetingConfirmation && (
          <ConfirmationStatus 
            offset={offset}
            isHideTime={isHideDetailingInformation && userId !== member.id}
            confirmationUser={meetingConfirmation.find((confirmation) => confirmation.userId === member.id)}
            userId={member.id}
            initiatorId={initiator.id}
          />
        )}
      </div>
    </div>
  )
}